import React from "react";
import { Icons, IconButton, Tooltip } from "@curves/ui-base";

const BatchActionSendMessage = ({ getCheckedSourceData, openDialog, refresh }) => {
	const handleClick = () => {
		let params = getCheckedSourceData();
		if (params.length === 0) return;
		params = params.map(({ memberID, nickName, name }) => ({ id: Number(memberID), type: 2, name: nickName || name }));
		if (typeof openDialog === "function") openDialog(params, refresh);
	};
	return (
		<Tooltip title="發送簡訊">
			<IconButton onClick={handleClick}>
				<Icons.PaperPlane />
			</IconButton>
		</Tooltip>
	);
};

export default BatchActionSendMessage;
